<template>
  <div v-if="widgetPermitted">
    <div v-if="widgetConfig.length > 0" class="flex full-width text-h2 text-center">Worksheet</div>
    <v-row v-if="isRestrictionsSet" class="justify-center mt-4 pa-4" style="gap: 20px">
      <template v-for="(widget, ind) in widgetConfig">
        <v-col
          v-if="dataLoaded && isPermitted(widget)"
          :key="ind"
          cols="12"
          md="3"
          @click="$router.push(widget.link)"
          class="pa-5 bg-grey-radial widget-box d-flex flex-column full-width"
        >
          <!-- use <component :is here -->
          <component :is="getWidgetType(widget)" :config="widget"></component>
        </v-col>
      </template>
    </v-row>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import index from '@/modules/customerVbzWorksheet';
import DispoWidget from '@/modules/customerVbzWorksheet/widgets/DispoWidget.vue';
import Zueri9OpenServicesWidget from '@/modules/customerVbzWorksheet/widgets/Zueri9OpenServicesWidget.vue';
import SimpleNavigationWidget from '@/modules/customerVbzWorksheet/widgets/SimpleNavigationWidget.vue';
import wsMixin from '@/modules/customerVbzWorksheet/wsMixin';
import configMixin from '@/mixins/configMixin';

const WIDGETS_CONFIG = [
  {
    key: 'dispo', // references moduleConfig.viewsRestrictedToOneOfGroup keys
    type: 'DispoWidget',
    title: 'Dispo',
    subtitle: 'Offene Dienste',
    counts: 'openFSDuties',
    link: '/worksheet/dispo',
  },
  {
    key: 'zueri9', // references moduleConfig.viewsRestrictedToOneOfGroup keys
    type: 'Zueri9OpenServicesWidget',
    title: 'Züri 9',
    subtitle: 'Offene Dienste und Statistik',
    link: '/worksheet/zueri9',
  },
  {
    key: 'zueri9CustomerView', // references moduleConfig.viewsRestrictedToOneOfGroup keys
    type: 'SimpleNavigationWidget',
    title: 'Züri 9',
    subtitle: 'Kundenberater Ansicht',
    link: '/worksheet/zueri9-customer-view',
  },
  {
    key: 'admin', // references moduleConfig.viewsRestrictedToOneOfGroup keys
    type: 'SimpleNavigationWidget',
    title: 'Administration',
    subtitle: 'Züri 9',
    link: '/worksheet/admin',
  },
  {
    key: 'reporting', // references moduleConfig.viewsRestrictedToOneOfGroup keys
    type: 'SimpleNavigationWidget',
    title: 'Reporting',
    subtitle: 'Verschiedene Auswertungen',
    link: '/worksheet/reporting',
  },
];

const widgetTypes = {
  SimpleNavigationWidget,
  DispoWidget,
  Zueri9OpenServicesWidget,
};
export default {
  name: 'WorksheetNavigationWidget',
  mixins: [configMixin, wsMixin],
  props: {
    config: Object,
  },
  created() {
    WIDGETS_CONFIG.forEach((c) => {
      if (this.moduleConfig) {
        c.viewsRestrictedToOneOfGroupId = this.moduleConfig.viewsRestrictedToOneOfGroup[c.key];
      }
    });
    this.isRestrictionsSet = true;
  },
  data() {
    return {
      isRestrictionsSet: false,
    };
  },
  computed: {
    ...mapState('vbzWorksheet', ['dataLoaded']),
    ...mapState('profile', ['user']),
    widgetConfig() {
      return WIDGETS_CONFIG;
    },
    moduleConfig() {
      return this.getModuleConfig(index.moduleType);
    },
    viewsRestrictedToOneOfGroup() {
      console.debug('compute viewsRestrictedToOneOfGroup moduleConfig', this.moduleConfig);
      return this.moduleConfig ? this.moduleConfig.viewsRestrictedToOneOfGroup : null;
    },
    widgetPermitted() {
      if (this.config.restrictedToMembersOfGroup) {
        return this.mx_isUserPermittedWhenRestrictedToGroups(this.config.restrictedToMembersOfGroup.split(','));
      }
      return true;
    },
  },
  methods: {
    isPermitted(widget) {
      return this.mx_isUserPermittedWhenRestrictedToGroups(widget.viewsRestrictedToOneOfGroupId);
    },
    getWidgetType(widget) {
      return widgetTypes[widget.type];
    },
  },
};
</script>
<style scoped>
.theme--dark .bg-grey-radial {
  background: radial-gradient(ellipse, #3c6b7d, #188dce) !important;
  opacity: 0.9;
  color: #f0f0f0;
  transition: ease-in 1s;
}

.theme--light .bg-grey-radial {
  background: radial-gradient(ellipse, #46b7e0, #217b9b) !important;
  opacity: 0.9;
  color: #f0f0f0;
}

.widget-box {
  border-radius: 20px;
}
</style>
